export default "__VITE_ASSET__Z06SELiG__"